import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import CommonCardHeader from '../../../../coreComponents/CommonCardHeader';
import { useTranslation } from 'react-i18next';
import { AssistantExamResponse, ScoringData } from '../../../../types/Exams';
import AjaxSourcedData from '../../../formsAndTable/tables/dataTables/dataSource/AjaxSourcedData';
import { getExamScoringColumns } from '../../../../data/formsAndTable/tables/dataTables/DataSource';
import { Dispatch } from '@reduxjs/toolkit';
import { SetStateAction } from 'react';
import { NoDataComponent } from '../../../formsAndTable/forms/formControls/NoDataComponent';

type Props = {
  examData: AssistantExamResponse;
  handleInitiateScoring: () => void;
  handleScoringDetailsModalWindow: (row: ScoringData, key: 'tr' | 'q' | 'a' | 'p') => void;
};

const ExamScoring = (props: Props) => {
  const { t } = useTranslation();
  const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <Col sm="12">
      <Card>
        <Row className="d-flex justify-content-between">
          <Col sm="8">
            {' '}
            <CommonCardHeader title={t('courses.exam.examScoring')} />
          </Col>
          <Col sm="auto">
            {' '}
            <Col sm="12" className="pt-3 d-flex justify-content-end ">
              <Button
                className="me-3 w-100"
                onClick={props.handleInitiateScoring}
                color="success"
                outline
                // disabled={props.examData.scoring !== null && !props.examData.scoring?.failedScoring}
              >
                {t('scoring.initScoring')}
              </Button>
            </Col>
          </Col>
        </Row>

        <CardBody>
          <AjaxSourcedData
            data={props.examData.scoring ?? []}
            columns={getExamScoringColumns(t, viewerTz, props.handleScoringDetailsModalWindow)}
            noDataComponent={<NoDataComponent />}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ExamScoring;
